import { Theme } from '@mui/material/styles';
import { MOS_THRESHOLDS } from 'utils/webrtc/ConnectionQuality';

export type MosBucket = 'unknown' | 'bad' | 'poor' | 'fair' | 'good';

export const mosBucket = (score: number | null): MosBucket => {
  if (score === null) {
    return 'unknown';
  }
  if (score < MOS_THRESHOLDS.poor) {
    return 'bad';
  }
  if (score < MOS_THRESHOLDS.fair) {
    return 'poor';
  }
  if (score < MOS_THRESHOLDS.good) {
    return 'fair';
  }
  return 'good';
};

export const bucketColor = (theme: Theme, bucket: MosBucket): string => {
  switch (bucket) {
    case 'poor':
      return theme.palette.error.main;
    case 'fair':
      return theme.palette.warning.main;
    case 'good':
      return theme.palette.success.main;
    case 'unknown':
    case 'bad':
    default:
      return theme.palette.text.disabled;
  }
};
